export const navurl = {
  Login: "/login",
  ForgotPassword: "/forgot-password",
  ResetPassword: "/resetPassword",
  PasswordSuccess: "/password-success",
  Dashboard: "/export",
  ImportDashboard:"/import",
  Organizations: "/organization",
};
